<template>
	<div class="facial">
		<div class="wx_box">
			<div class="wx_main">
				<div class="top">
					<div class="wx_title">
						<span>植物脸谱</span>
					</div>
				</div>
				<div class="select_year">
					<span class="label">选择年份:</span>
					<el-date-picker v-model="year" type="year" format="yyyy" size="mini" value-format="yyyy"
						:picker-options="pickerOptions" placeholder="选择年" @change="changeYear">
					</el-date-picker>
				</div>
				<div class="tabs">
					<span :class="{'active':tabShowNum==item.id}" @click="clickArea(item.id)"
						v-for="(item,index) in area_list" :key="index">{{item.name}}</span>

				</div>
				<div class="select_year climate">
					<span class="label d_jump">气候：</span>
					<el-date-picker v-model="day" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="选择年月"
						style="width: 180px;">
					</el-date-picker>
					<el-button type="primary" class="climate_btn" @click="changeDay">确定</el-button>
				</div>
				<div class="climate_box">
					<div class="climate_item" v-for="(item,index) in weatherList" :class="{'active':index==10}">
						<div class="num">{{item.date}}</div>
						<div class="degrees">{{item.min_temp}}℃-{{item.max_temp}}℃</div>
						<div class="state">{{item.weather}}</div>
						<div class="windSpeed">{{item.wind_direction}}</div>
						<!--<div class="quality">{{item.quality}}</div> -->
					</div>
				</div>
				<h4 class="subTitle d_jump">土壤</h4>
				<div class="charts_item">
					<div class="bar_charts">
						<wxEcharts :chartsData="chartsData1" key="1" v-if="flag"></wxEcharts>
					</div>
					<div class="bar_charts">
						<wxEcharts :chartsData="chartsData2" key="2" v-if="flag"></wxEcharts>
					</div>
				</div>
				<div v-for="(item,index) in base_list" :key="'table'+index" v-if="item.task_list.length>0">
					<h4 class="subTitle d_jump">{{item.base_name}}</h4>
					<div class="subMsg" v-if="task.length>0">
						<span>{{task[item.base_id].display_run_time}}</span>
						<span style="display: none;">物候期: {{task[item.base_id].enophase_name}}</span>
						<span>正常比例为: {{task[item.base_id].rates}}％</span>
					</div>
					<div class="plant">
						<div class="echarts_box">
							<wxPie :pieData="pieData[item.base_id]" :key="'base_pie'+index" v-if="pie==true"
								:ref="'pie'+item.base_id"></wxPie>
						</div>
						<div class="img_box">
							<div class="big_img">
								<!-- <el-link :href="imgURL1[item.base_id]" target="_blank"> -->
									<el-image :src="imgURL1[item.base_id]" alt="" :preview-src-list="imgURL1"></el-image>
								<!-- </el-link> -->
							</div>
							<div class="small_img">
								<span class="fl">{{title1[item.base_id]}}</span>
								<div class="fr">

									<el-image :class="{'active':imgShowNum1==val.value}" :src="val.url" alt=""
										@click="imgClick1(item.base_id,val.url,val.target_name),imgShowNum1 = val.value"
										v-for="(val,key) in images_list[item.base_id]" :key="'image'+key"></el-image>

								</div>
							</div>
						</div>
						<div class="plant_tab">
							<table class="my_table">
								<thead>
									<tr>
										<th width="40">采集日期</th>
										<th width="100" style="display: none;">物候期</th>
										<th width="150" v-for="(val,key) in item.target_list">{{val.name}}</th>

										<th width="150">正常比例</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(v,k) in item.task_list"
										@click="setZeroTask(item.base_id,item.base_name,v)" style="cursor: pointer;"
										:key="'task'+k">
										<td>{{v.display_run_time}}</td>
										<td style="display: none;">{{v.enophase_name}}</td>
										<td v-for="(vs,ks) in v.target_list">{{vs.rates}}％
										<el-link  v-for="(img,idx) in vs.images" target="_blank" :key="'images'+idx">
												<el-image :src="img" alt="" :preview-src-list="vs.images"></el-image>
												</el-link>
										</td>
										<td>{{v.rates}}％</td>
									</tr>
								</tbody>
								<div class="pagination" :key="'pages'+item.base_id">
									<el-pagination @current-change="(val) => handleCurrentChange(item.base_id, val)"
										:current-page="tabPage[item.base_id].currentPage" :page-sizes="[10, 20, 30, 40]"
										:page-size="tabPage[item.base_id].pagesize" background
										layout="prev, pager, next" :total="total[item.base_id]" v-if="page"
										:key="'page'+item.base_id">
									</el-pagination>
								</div>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--跳转定位-->
		<div class="location">
			<div class="wx_item" :class="{'active':locationShowNum==index}" v-for="(item,index) in locationList"
				@click="locationClick(index)" style="cursor: pointer;" >
				{{item}}
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getFarmFacial,
		getFarmFacialWeather
	} from '@/api/facial'
	import {
		getFarmInfo
	} from '@/api/api'
	var echarts = require('echarts');
	import wxEcharts from '@/components/LineFacial';
	import wxPie from '@/components/PieEchartsFacial.vue';
	export default {
		name: "facial",
		data() {
			return {
				flag: false,
				pie: true,
				page: false,
				farm_id: '',
				pickerOptions: this.disabledDate(),
				year: new Date().getFullYear().toString(),
				farm_reg_year:"",
				
				day: this.get_day(),
				tabShowNum: 0,
				weatherShowNum: 0,
				area_list: [],
				base_list: [],
				images_list: [],
				tabPage: [],
				total: [],

				imgShowNum1: 0,
				imgShowNum2: 0,
				weatherList: [],
				chartsData1: {
					title: '湿度',
					xAxisData: [],
					yAxisName: '单位：%',
					highData: []
				},
				chartsData2: {
					title: '温度',
					xAxisData: [],
					yAxisName: '单位：℃',
					myData: []
				},
				pieData: [],

				imgURL1: [],
				imgURL2: require('../../assets/images/growth/yepian.png'),
				title1: [],
				title2: '深绿色',

				task: [],
				locationList: [],
				locationShowNum: 0
			}
		},
		created() {
			this.farm_id = this.$route.params.id
			getFarmInfo(this.$route.params.id).then(resp => {
			
			
				if(resp.farm.is_check==1){
					this.get_farm_facial_weather()
				}else{
					this.$message.error("请先完善农事管理板块相关申请工作，才能开通此板块！")
					this.$router.push("/park/detail/"+this.$route.params.id)
				}
				})
			

		},
		methods: {
			disabledDate() {
				let that = this
				console.log(that.year_list)
				return {
					disabledDate(date) {
						let result=true
						if(that.farm_reg_year>=date.getFullYear())
						{
					    result=false
						}else{
						
						}
						return result						
					}
				}
			},
			clickArea(id) {
				this.tabShowNum = id
				this.get_farm_facial(id)
			},
			changeYear() {
				this.get_farm_facial_weather()
			},
			changeDay() {
				this.get_farm_facial_weather()
			},

			handleCurrentChange(base_id, currentPage) {

				this.tabPage[base_id].currentPage = currentPage;
				this.get_farm_facial(this.tabShowNum)
				//console.log(this.currentPage)  //点击第几页
			},
			get_farm_facial(area_id) {
				let that = this

				getFarmFacial(this.farm_id, area_id, this.year, this.tabPage).then(resp => {
					
					console.log(resp)
						this.farm_reg_year=resp.farm_reg_year				
                      this.setLineTask(resp)
					this.locationList = ["气候", "土壤"]
					resp.all_base_list.forEach((val,key)=>{
						this.tabPage[val.id] = {
								currentPage: 1,
								pagesize: 10
							}
					})
					resp.base_list.forEach((item, index) => {
						this.title1[item.base_id] = '',
							this.imgURL1[item.base_id] = '',
							this.pieData[item.base_id] = {}
						this.pieData[item.base_id].seriesName = '',

							this.pieData[item.base_id].pieEchartsData = []
					if(item.task_list.length>0){		
						this.locationList.push(item.base_name)
                      }
						//	  this.tabPage[item.base_id]=[]
						this.total[item.base_id] = item.total
						

                         if(item.task_list.length>0){
							this.setZeroTask(item.base_id, item.base_name, item.task_list[0])
							}
						this.page = true
						//  console.log(this.tabPage[item.base_id].pagesize)

					})
					// console.log(this.tabPage)
					// console.log(this.tabPage1)
					this.base_list = resp.base_list
					// console.log(this.pieData1)
					// this.pie=true
					this.page = true
					// console.log(this.task)


				})
			},
			setLineTask(resp){
				this.flag=false
				var chartsData1={xAxisData:[],highData:[],yAxisName: '单位：%',title: '湿度'}
				var chartsData2={xAxisData:[],myData:[],yAxisName: '单位：℃',title: '温度'}
		chartsData1.xAxisData = resp.soilyear
				
				chartsData1.highData = resp.wet_list
				chartsData2.xAxisData = resp.soilyear
				chartsData2.myData = resp.temp_list
				this.$nextTick(() => {
					this.flag = true
				})
				this.chartsData1 = chartsData1
				this.chartsData2 = chartsData2
			},
			setZeroTask(base_id, base_name, item) {

				this.pie = false
				this.task[base_id] = item
				this.images_list[base_id] = []
				var pieDatas = {
					seriesName: '',
					pieEchartsData: []
				}
				item.target_list.forEach((val, key) => {
					//console.log(val)
					pieDatas.seriesName = base_name
					pieDatas.pieEchartsData.push({
						name: val.target_name,
						value: val.rates
					})
					val.images.forEach((v, k) => {
						if (this.images_list[base_id].length < 5) {
							const length = this.images_list[base_id].length
							this.images_list[base_id].push({
								target_name: val.target_name,
								url: v,
								value: val.id + length
							})
						}
					})
				})
				this.$nextTick(() => {
					this.pie = true
				})
				this.pieData[base_id] = pieDatas

                 if(item["target_list"].length>0){ 
					let imgURL1=''
					 let title1=''
                      item['target_list'].forEach((val,key)=>{
						   if(val.images.length>0){
							   this.title1[base_id] = item['target_list'][key]['target_name']
							   this.imgURL1[base_id] = item['target_list'][key]['images'][0]
						   }else{
							  // this.title1[base_id]='暂无图片'
							  //  this.imgURL1[base_id]=''
						   }
					  })
			
			    /*  this.title1[base_id]='暂无图片'
			       this.imgURL1[base_id]='' */
				//cons this.imgClick1(base_id,item['target_list'][0]['images'][1],item['target_list'][0]['target_name'])
				}

               
			},
			get_farm_facial_weather() {
				getFarmFacialWeather(this.farm_id, this.year, this.day).then(resp => {
					this.weatherList = resp.weather_list
					this.area_list = resp.area_list
					if (resp.area_list.length > 0) {
						this.clickArea(resp.area_list[0]["id"])
					}
				})
			},

			get_day() {
				let date = new Date()
				const month = date.getMonth() + 1
				const year = date.getFullYear()
				const day = date.getDate()

				return year + "-" + month + "-" + day
			},

			imgClick1(base_id, url, title) {
				console.log(title+"dada"+url)

				this.imgURL1[base_id] = url
				this.title1[base_id] = title

				console.log(this.imgURL1)
			},
			imgClick2(url, title) {
				this.imgURL2 = url
				this.title2 = title
			},
			locationClick(index) {
				// 用 class="d_jump" 添加锚点
				let jump = document.querySelectorAll('.d_jump')
				let total = jump[index].offsetTop
				let distance = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
				// 平滑滚动，时长500ms，每10ms一跳，共50跳
				let step = total / 50
				if (total > distance) {
					smoothDown()
				} else {
					let newTotal = distance - total
					step = newTotal / 50
					smoothUp()
				}

				function smoothDown() {
					if (distance < total) {
						distance += step
						document.body.scrollTop = distance
						document.documentElement.scrollTop = distance
						window.pageYOffset = distance
						setTimeout(smoothDown, 10)
					} else {
						document.body.scrollTop = total
						document.documentElement.scrollTop = total
						window.pageYOffset = total
					}
				}

				function smoothUp() {
					if (distance > total) {
						distance -= step
						document.body.scrollTop = distance
						document.documentElement.scrollTop = distance
						window.pageYOffset = distance
						setTimeout(smoothUp, 10)
					} else {
						document.body.scrollTop = total
						document.documentElement.scrollTop = total
						window.pageYOffset = total
					}
				}
				this.locationShowNum = index
			},
		},
		mounted() {
			// let jump = document.querySelectorAll(".d_jump");
			// let offSetTop1 = jump[0].offsetTop;
			// let offSetTop2 = jump[1].offsetTop;
			// let offSetTop3 = jump[2].offsetTop;
			// let offSetTop4 = jump[3].offsetTop;

			this.$nextTick(() => {
				window.addEventListener("scroll", () => {
					let scrolled = document.documentElement.scrollTop || document.body.scrollTop;
					if (scrolled <= 400) {
						this.locationShowNum = 0
					} else if (scrolled < 1000 && scrolled >= 400) {
						this.locationShowNum = 1
					} else if (scrolled < 1500 && scrolled >= 1000) {
						this.locationShowNum = 2
					} else if (scrolled < 2020 && scrolled >= 1500) {
						this.locationShowNum = 3
					} else {

					}
				})
			})
		},
		components: {
			wxEcharts,
			wxPie
		}
	}
</script>

<style lang="less">
	.facial {
		padding-left: 145px;
		.wx_box {
			.wx_main {
				padding: 17px 17px 80px 18px;
				background: radial-gradient(rgba(19, 62, 173, 0.74), rgba(5, 18, 32, 0.47));

				.top {
					width: 100%;
					overflow: hidden;
				}

				.select_year {
					margin-top: 25px;
					display: flex;
					align-items: center;

					.label {
						width: 80px;
						font-size: 16px;
						color: #91AFBA;
					}

					.el-date-editor {
						width: 180px;
					}

					.el-input__inner {
						width: 180px;
						text-align: center;
						font-size: 16px;
					}

					.climate_btn {
						width: 150px;
						height: 30px;
						line-height: 30px;
						padding: 0;
						margin-left: 120px;
					}
				}
				.climate{
					.el-input__inner{
						width: 180px;
					}
				}
				.climate_box {
					display: flex;
					flex-wrap: wrap;
					margin-top: 20px;

					.climate_item {
						margin-right: 1px;
						margin-bottom: 1px;
						background: rgba(212, 249, 255, 0.11);
						width: 255px;
						height: 186px;
						color: #fff;
						text-align: center;
						font-size: 16px;

						// cursor: pointer;
						.num {
							padding: 18px 0 0 21px;
							text-align: left;
							font-size: 18px;
						}

						.degrees {
							padding-top: 15px;
						}

						.state {
							padding-top: 15px;
						}

						.windSpeed {
							padding-top: 5px;
						}

						.quality {
							display: inline-block;
							margin-top: 15px;
							padding: 1px 23px;
							background-color: #00A1E6;
							border-radius: 11px;
							font-size: 14px;
						}
					}

					.active {
						background: rgba(212, 249, 255, 0.2303);
					}
				}

				.subTitle {
					font-size: 18px;
					font-weight: 600;
					color: #10FFCA;
					padding-top: 39px;
				}

				.charts_item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					border-bottom: 1px solid rgba(0, 161, 230, 0.2716);
					padding-bottom: 46px;

					.bar_charts {
						width: 800px;
					}
				}

				.subMsg {
					margin-top: 30px;

					span {
						color: #fff;
						font-size: 18px;
						font-weight: 500;
						padding-left: 30px;
					}
				}

				.plant {
					display: flex;
					align-items: center;
					justify-content: space-between;
					border-bottom: 1px solid rgba(0, 161, 230, 0.2716);
					padding-bottom: 46px;

					&:last-child {
						border-bottom: 0;
					}

					.img_box {
						width: 360px;
						height: 300px;
						position: relative;

						.big_img {
							width: 360px;
							height: 300px;

							img {
								width: 360px;
								height: 300px;
							}
						}

						.small_img {
							width: 100%;
							height: 40px;
							position: absolute;
							bottom: 0;
							left: 0;
							background-color: rgba(18, 18, 18, .6);

							span {
								font-size: 18px;
								font-weight: 400;
								color: #FFFFFF;
								line-height: 40px;
								padding-left: 24px;
							}

							div {
								height: 100%;
								display: flex;
								align-items: center;

								img {
									width: 44px;
									height: 30px;
									margin-right: 12px;
									cursor: pointer;
								}

								.active {
									border: 1px solid #fff;
								}
							}
						}
					}

					.echarts_box {
						width: 500px
					}

					.my_table {
						thead {
							tr {
								th {
									font-size: 16px;
								}
							}
						}

						tbody {
							tr {
								td {
									font-size: 16px;
									padding: 6px 0;

									img {
										width: 16px;
										height: 15px;
										margin-left: 5px;
									}
								}
							}
						}
					}
				}

				.tabs {
					display: flex;
					margin-top: 20px;

					span {
						width: 150px;
						height: 22px;
						border: 1px solid #2B92F6;
						line-height: 22px;
						font-size: 14px;
						color: #fff;
						text-align: center;
						cursor: pointer;
					}

					.active {
						background: #2B92F6;
						color: #fff;
					}
				}
			}
		}

		.location {
			min-width: 150px;
			position: fixed;
			top: 30%;
			left: 0;
			background: radial-gradient(rgba(19, 62, 173, 0.74), rgba(5, 18, 32, 0.47));
			z-index: 1000;
			padding: 10px 0;
			&:before {
				content: '';
				width: 1px;
				height: 100%;
				background-color: #004690;
				position: absolute;
				left: 20px;
				top: 0;
				z-index: 998;
			}

			.wx_item {
				height: 40px;
				line-height: 40px;
				position: relative;
				padding: 0 10px 0 50px;
				font-size: 14px;
				color: #fff;

				&:before {
					content: '';
					width: 20px;
					height: 20px;
					border-radius: 50%;
					border: 1px solid #fff;
					position: absolute;
					left: 10px;
					top: 50%;
					margin-top: -10px;
					z-index: 1000;
					background-color: transparent;
				}
			}

			.active {
				&:before {
					content: '';
					width: 20px;
					height: 20px;
					border-radius: 50%;
					border: 1px solid #fff;
					background-color: #2B92F6;
					position: absolute;
					left: 10px;
					top: 50%;
					margin-top: -10px;
				}
			}
		}
	}
</style>
